var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.62996 13.4721C1.78996 13.4721 1.82196 13.4561 1.96596 13.4241L4.84596 12.8481C5.14996 12.7681 5.45396 12.6241 5.69396 12.3841L12.67 5.40809C13.742 4.33609 13.742 2.49609 12.67 1.42409L12.078 0.800094C11.006 -0.271906 9.14996 -0.271906 8.07796 0.800094L1.10196 7.79209C0.877962 8.01609 0.717962 8.33609 0.637962 8.64009L0.0299624 11.5521C-0.0500376 12.0961 0.109962 12.6241 0.493962 13.0081C0.797962 13.3121 1.24596 13.4721 1.62996 13.4721ZM2.17396 8.94409L9.14996 1.95209C9.61396 1.48809 10.462 1.48809 10.91 1.95209L11.518 2.56009C12.062 3.10409 12.062 3.87209 11.518 4.40009L4.55796 11.3921L1.59796 11.8881L2.17396 8.94409Z",
    fill: "#13123A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6059 14.4639H0.797907C0.333907 14.4639 0.0299072 14.7679 0.0299072 15.2319C0.0299072 15.6959 0.413907 15.9999 0.797907 15.9999H12.5419C13.0059 15.9999 13.3899 15.6959 13.3899 15.2319C13.3739 14.7679 12.9899 14.4639 12.6059 14.4639Z",
    fill: "#13123A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRename);
export default __webpack_public_path__ + "static/media/ic_rename.b1cba8aa3cdbd21e35bfb1b7fcece5f9.svg";
export { ForwardRef as ReactComponent };